<template lang="pug">
.row
  .columns.large-24
    article
        section#find-programs
          form(@submit.prevent="search")
            .row
                .form-col.large-16
                    .field
                        FloatingLabel(:config="{label: t('app.organizations.search_an_organization')}")
                            input.search-input(type="text" v-model="query.query" :placeholder="t('app.organizations.search_an_organization')")
                .form-col.large-4
                    .field
                        .select
                            span.selected
                                span.value {{STATE_CODES[query.query_state]||t('helpers.placeholder.address.state')}}
                                span.caret
                            select(v-model="query.query_state")
                                option(value="") {{ t('helpers.placeholder.address.state') }}
                                option(v-for="state in STATES" :value="state") {{STATE_CODES[state]}}
                .form-col.large-4
                    .field
                        button.right.button(type="submit") {{t("app.programs.search.button")}}
</template>
<script>
import states from "../../states";
export default {
  mixins: [states],
  data(){
    return {
      query: {}
    }
  },
  created() {
    this.query = this.clone_obj(this.$route.query)
  },
  methods: {
    search(){
      this.$router.replace({query: this.query}).catch(_=>{})
    }
  }
}
</script>